import { render, staticRenderFns } from "./customClass-editor.vue?vue&type=template&id=607e4904&scoped=true&"
import script from "./customClass-editor.vue?vue&type=script&lang=js&"
export * from "./customClass-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e4904",
  null
  
)

export default component.exports